
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Plinto case-study page behaviour: the data-driven tab sections.
// Mirrors the Repper page pattern (src/js/repper.js).
//
// Images/media are imported (not referenced as string paths) so the bundler
// fingerprints them and emits them to the build output.
// ── PLACEHOLDER media ──────────────────────────────────────────────────────
// Real Plinto assets aren't in yet, so we reuse existing Repper images. When
// the real assets land, drop them in src/assets/images/plinto/ and swap these
// imports + the `media.src` references below.
var $5c4827fc2efe4a4a$exports = {};
$5c4827fc2efe4a4a$exports = import.meta.resolve("kC7hL");


var $28b68444d6a851a8$exports = {};
$28b68444d6a851a8$exports = import.meta.resolve("ded5V");


var $2d88b608ba239077$exports = {};
$2d88b608ba239077$exports = import.meta.resolve("30B8g");


var $eedd117c23732296$exports = {};
$eedd117c23732296$exports = import.meta.resolve("kyPmX");


var $6af8ce4ae09361ad$exports = {};
$6af8ce4ae09361ad$exports = import.meta.resolve("67SZr");


var $98940956de8362df$exports = {};
$98940956de8362df$exports = import.meta.resolve("eeYan");


var $b115301bffd5cd69$exports = {};
$b115301bffd5cd69$exports = import.meta.resolve("2PVYQ");


var $5e4e9035fed3f596$exports = {};
$5e4e9035fed3f596$exports = import.meta.resolve("a17wz");


var $5b1b5a58e61dfccd$exports = {};
$5b1b5a58e61dfccd$exports = import.meta.resolve("3PJ4r");


var $4255a6cbf88158e1$exports = {};
$4255a6cbf88158e1$exports = import.meta.resolve("cI0HW");


var $f66130ca084fc181$exports = {};
$f66130ca084fc181$exports = import.meta.resolve("cna6a");


var $c6348368eb11280a$exports = {};
$c6348368eb11280a$exports = import.meta.resolve("laZuR");


var $d49d860a6d759af5$exports = {};
$d49d860a6d759af5$exports = import.meta.resolve("Kc9g9");


/* ── Tab sections ──────────────────────────────────────────────────────────
   To edit copy or swap media, only this data structure needs to change.
   media.type is 'image' or 'video'. `eyebrow` is an optional small title that
   renders above the section heading. */ const $3b3e3c27a725006f$var$sections = [
    {
        mount: 'design-foundation',
        heading: 'Creating a design foundation',
        // Index of the tab shown when the section first renders (defaults to 0).
        defaultTab: 1,
        // `intro` can be a plain string or an array of blocks (paragraphs and
        // { subtitle } small titles) for richer left-column copy.
        intro: [
            'The UI had grown screen by screen, so my first goal was to create unity in layout and visual design. There were already tables and lists, central to financial controlling; now came a layer of AI on top. I reduced the chrome, relying mostly spacing and lines to segment the UI. This created space for the new AI reviews to stand out.',
            {
                subtitle: 'AI in budget review'
            },
            'The Budget review is where financial controllers get both an overview of an asset as well as hunt for exceptions that need attention. To meet both needs, I layered the AI review: summary for the overall verdict, issues per account bubbling up in the tree structure, and all details in the sidebar.'
        ],
        tabs: [
            {
                label: 'Before',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2d88b608ba239077$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Plinto style foundations (placeholder)'
                }
            },
            {
                label: 'After (overview)',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5c4827fc2efe4a4a$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Plinto components (placeholder)'
                }
            },
            {
                label: 'After (sidebar)',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($28b68444d6a851a8$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Plinto review examples (placeholder)'
                }
            }
        ]
    },
    {
        mount: 'custom-solutions',
        heading: 'Solutions meeting context ',
        intro: "Plinto's users live in complex systems like ERP. We didn't believe that software in this domain needs to be clunky or hard to navigate. At the same time, our users value utility and efficiency, and so where fit, I created custom solutions to better fit specific use cases. This balancing act meant often repurposing well-known UI patterns in new ways.",
        tabs: [
            {
                label: 'Period picker',
                body: 'The original period picker was simply two date pickers. Since months, quarters and years are the most common periods used by the users, I brought those to the foreground and structured them so they were each to pick. A second QoL improvement: any custom date range would be presented as simple as possible, breaking in into year, quarter or month ranges where applicable (see right picker).',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6af8ce4ae09361ad$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Plinto custom card (placeholder)'
                }
            },
            // {
            //   label: 'AI assistance',
            //   body: "Plinto revolves around controls, which are checks being run on accounts and invoices. We built an AI-assisted creation flow, which lets the user loosely explain what they're after and get a detailed control back.",
            //   media: {
            //     type: 'image',
            //     src: placeholderE,
            //     width: 800,
            //     height: 517,
            //     alt: 'Plinto form layout (placeholder)',
            //   },
            // },
            {
                label: 'Actions in context',
                body: "As we're moving from AI review to agentic actions, we need a consistent way to display them across the UI. This is an proposal of how that can work in cards, sidebars, and timelines.",
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($eedd117c23732296$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Plinto calendar (placeholder)'
                }
            }
        ]
    },
    {
        mount: 'second-iteration',
        heading: 'Second visual iteration',
        intro: "Before the end of my contract, I did a second interation on the design system. The product had grown a lot in a short time and there was again a need for more breathing space and finetuning the UI's balance and contrast. Among dozens of tweaks, I straightened the layout, separated the navbar out, receded all interactive UI slightly to lift content to the foreground, an balanced out all text styles.",
        tabs: [
            {
                label: 'Sidebar',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5b1b5a58e61dfccd$exports))),
                    width: 1496,
                    height: 935,
                    alt: "Plinto second iteration \u2014 sidebar"
                }
            },
            {
                label: 'Alignment',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($98940956de8362df$exports))),
                    width: 1496,
                    height: 935,
                    alt: "Plinto second iteration \u2014 alignment"
                }
            },
            {
                label: 'Table',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4255a6cbf88158e1$exports))),
                    width: 1496,
                    height: 935,
                    alt: "Plinto second iteration \u2014 table"
                }
            },
            {
                label: 'Overview',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5e4e9035fed3f596$exports))),
                    width: 1496,
                    height: 935,
                    alt: "Plinto second iteration \u2014 overview"
                }
            },
            {
                label: 'Controls',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b115301bffd5cd69$exports))),
                    width: 1496,
                    height: 935,
                    alt: "Plinto second iteration \u2014 controls"
                }
            }
        ]
    }
];
// width/height attributes let the browser reserve the aspect-ratio box before
// the image loads, so the panel doesn't jump in height once it arrives.
const $3b3e3c27a725006f$var$dims = (media)=>media.width && media.height ? ` width="${media.width}" height="${media.height}"` : '';
const $3b3e3c27a725006f$var$mediaMarkup = (media)=>media.type === 'video' ? `<video controls playsinline poster="${media.poster ?? ''}" src="${media.src}"${$3b3e3c27a725006f$var$dims(media)}></video>` : `<img src="${media.src}" alt="${media.alt ?? ''}"${$3b3e3c27a725006f$var$dims(media)} />`;
// A text block is either a paragraph (string) or a small title ({ subtitle }).
const $3b3e3c27a725006f$var$blockMarkup = (block)=>typeof block === 'string' ? `<p>${block}</p>` : block.subtitle ? `<h3 class="reflection-subtitle">${block.subtitle}</h3>` : '';
// An optional title shows inline, in the default text color, before an em dash.
// Returns '' when neither title nor body is provided.
const $3b3e3c27a725006f$var$bodyMarkup = (tab)=>{
    const title = tab.title ? `<span class="reflection-panel__title">${tab.title}</span>` : '';
    if (title && tab.body) return `${title} \u{2014} ${tab.body}`;
    return title || tab.body || '';
};
const $3b3e3c27a725006f$var$renderPanel = (panel, tab)=>{
    const body = $3b3e3c27a725006f$var$bodyMarkup(tab);
    panel.innerHTML = `
    ${body ? `<div class="reflection-panel__body">${body}</div>` : ''}
    <div class="reflection-panel__media">${$3b3e3c27a725006f$var$mediaMarkup(tab.media)}</div>`;
};
const $3b3e3c27a725006f$var$initializeVideoFacades = (root = document)=>{
    root.querySelectorAll('.video-facade[data-video-src]').forEach((facade)=>{
        facade.addEventListener('click', ()=>{
            const video = document.createElement('video');
            video.src = facade.dataset.videoSrc;
            video.poster = facade.dataset.videoPoster ?? '';
            video.controls = true;
            video.playsInline = true;
            video.autoplay = true;
            video.preload = 'metadata';
            facade.replaceWith(video);
            video.play().catch(()=>{});
        }, {
            once: true
        });
    });
};
// The static hero / hero-media / role markup that used to live in plinto.html.
// Class names match the existing CSS, so styling applies unchanged.
const $3b3e3c27a725006f$var$contentMarkup = ()=>`
  <section class="project-hero">
    <hgroup>
      <img class="icon" src="${0, (/*@__PURE__*/$parcel$interopDefault($f66130ca084fc181$exports))}" alt="Plinto icon" />
      <h1>Plinto</h1>
    </hgroup>
    <p class="project-description">
      An AI assistant that makes financial controlling comprehensive,
      accurate, and continuous. Controllers orchestrate while Plinto
      handles.
    </p>
    <dl class="fact-grid">
      <div class="fact-col">
        <dt>Type</dt><dd>AI Fintech</dd>
        <dt>Year</dt><dd>Sep 2025 - Jun 2026</dd>
      </div>
      <div class="fact-col">
        <dt>Role</dt><dd>Contractor</dd>
        <dt>Activities</dt><dd>Design system, product design, frontend</dd>
      </div>
    </dl>
  </section>

  <section class="project-section">
    <div class="media-embed">
      <button
        class="video-facade"
        type="button"
        data-video-src="${0, (/*@__PURE__*/$parcel$interopDefault($c6348368eb11280a$exports))}"
        data-video-poster="${0, (/*@__PURE__*/$parcel$interopDefault($d49d860a6d759af5$exports))}"
        aria-label="Play video: Plinto product walkthrough"
      >
        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($d49d860a6d759af5$exports))}" alt="" />
        <span class="video-facade__play" aria-hidden="true"></span>
      </button>
    </div>
  </section>

  <section class="project-section project-section--boxed">
    <p class="text-body text-balance">
      Plinto had a strong technical basis going towards a pre-seed round
      and wanted to elevate it to a real product feel. Without designer
      and with founders stretched thin, they
      needed someone who could take any task and run with it. I touched
      most parts of the product, from new features to the design foundation below, 
      within a budget of 2 days a week.
    </p>
  </section>

  ${$3b3e3c27a725006f$var$sections.map((section)=>`<section class="reflection-tabs" data-reflection="${section.mount}"></section>`).join('')}`;
// Renders the case-study content into <main>. Idempotent — a second call is a no-op.
let $3b3e3c27a725006f$var$rendered = false;
function $3b3e3c27a725006f$export$5999ca150006b0ea() {
    if ($3b3e3c27a725006f$var$rendered) return;
    const main = document.querySelector('main');
    if (!main) return;
    main.innerHTML = $3b3e3c27a725006f$var$contentMarkup();
    $3b3e3c27a725006f$var$rendered = true;
    $3b3e3c27a725006f$var$initializeVideoFacades(main);
    $3b3e3c27a725006f$var$buildSections();
}
$3b3e3c27a725006f$export$5999ca150006b0ea();
function $3b3e3c27a725006f$var$buildSections() {
    $3b3e3c27a725006f$var$sections.forEach((section)=>{
        const root = document.querySelector(`.reflection-tabs[data-reflection="${section.mount}"]`);
        if (!root) return;
        const heading = document.createElement('h2');
        heading.className = 'reflection-tabs__heading';
        heading.textContent = section.heading;
        // An optional small title (eyebrow) sits above the heading. When present we
        // group it with the heading so the pair occupies the grid "heading" area.
        let headingCell = heading;
        if (section.eyebrow) {
            const eyebrow = document.createElement('p');
            eyebrow.className = 'reflection-tabs__eyebrow';
            eyebrow.textContent = section.eyebrow;
            headingCell = document.createElement('div');
            headingCell.className = 'reflection-tabs__heading-group';
            headingCell.append(eyebrow, heading);
        }
        // `intro` is either a plain string (single paragraph) or an array of blocks.
        let lead;
        if (Array.isArray(section.intro)) {
            lead = document.createElement('div');
            lead.className = 'reflection-tabs__lead';
            lead.innerHTML = section.intro.map($3b3e3c27a725006f$var$blockMarkup).join('');
        } else {
            lead = document.createElement('p');
            lead.className = 'reflection-tabs__lead';
            lead.textContent = section.intro;
        }
        const tabbar = document.createElement('div');
        tabbar.className = 'reflection-tabbar';
        tabbar.setAttribute('role', 'tablist');
        const panel = document.createElement('div');
        panel.className = 'reflection-panel';
        panel.setAttribute('role', 'tabpanel');
        const defaultTab = section.defaultTab ?? 0;
        const buttons = section.tabs.map((tab, i)=>{
            const button = document.createElement('button');
            button.className = 'reflection-tab';
            button.type = 'button';
            button.textContent = tab.label;
            button.setAttribute('role', 'tab');
            button.setAttribute('aria-selected', String(i === defaultTab));
            button.addEventListener('click', ()=>{
                buttons.forEach((b)=>b.setAttribute('aria-selected', 'false'));
                button.setAttribute('aria-selected', 'true');
                $3b3e3c27a725006f$var$renderPanel(panel, tab);
            });
            tabbar.appendChild(button);
            return button;
        });
        // Append in reading order (heading → lead → tabs → panel); grid areas place them.
        root.append(headingCell, lead, tabbar, panel);
        $3b3e3c27a725006f$var$renderPanel(panel, section.tabs[defaultTab]);
    });
}


//# sourceMappingURL=plinto.3bcb6bd6.js.map
